var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 0H2.55C1.8737 0 1.2251 0.293494 0.746878 0.815917C0.26866 1.33834 0 2.0469 0 2.78571V10.2143C0 10.9531 0.26866 11.6617 0.746878 12.1841C1.2251 12.7065 1.8737 13 2.55 13H14.45C15.1263 13 15.7749 12.7065 16.2531 12.1841C16.7313 11.6617 17 10.9531 17 10.2143V2.78571C17 2.0469 16.7313 1.33834 16.2531 0.815917C15.7749 0.293494 15.1263 0 14.45 0ZM3.4 10.2143H2.55V2.78571H3.4V10.2143ZM5.95 10.2143H4.25V2.78571H5.95V10.2143ZM7.65 10.2143H6.8V2.78571H7.65V10.2143ZM11.05 10.2143H8.5V2.78571H11.05V10.2143ZM12.75 10.2143H11.9V2.78571H12.75V10.2143ZM14.45 10.2143H13.6V2.78571H14.45V10.2143Z",
    fill: "#B6B7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.1d67f430.svg";
export { ForwardRef as ReactComponent };